import { ReactNode } from "react";

type BaseSectionType = {
  classProps?: string;
  height?: string;
  width?: string;
  paddings?: string;
  bgcolor?: string;
  flexCol?: boolean;
  gap?: string;
  children: ReactNode;
};

export default function BaseSection(props: BaseSectionType) {
  return (
    <section
      className={`w-full ${props.height ?? "h-fit"} flex ${props.classProps} ${
        props.gap ?? "gap-2"
      } ${props.paddings ?? "py-48"} ${props.width ?? "max-w-screen-xl"} ${
        props.bgcolor
      } ${props.flexCol && "flex-col"}`}
    >
      {props.children}
    </section>
  );
}
